"use strict";

import { useCallback, useEffect, useState } from "react";

import { getPendingRemuxRequest, recordRemuxRequest, remuxRequestBlocker } from "./remuxRequest.js";
import { TASK_STATUS } from "./taskStatuses.js";

/**
 * Keeps the last Re-remux request until the status poll shows its merge job
 * running, so the button stays disabled in between.
 *
 * `pending` is the request while it waits to start, `blocker` says why the
 * button is disabled meanwhile, and `record` / `clear` are called when a
 * request is sent and when sending it fails.
 */
export const useRemuxRequest = (mergingStatus, languageName) => {
    const [request, setRequest] = useState(null);

    useEffect(() => {
        if (mergingStatus === TASK_STATUS.inProgress) {
            setRequest(null);
        }
    }, [mergingStatus]);

    const record = useCallback((language) => setRequest(recordRemuxRequest(language)), []);
    const clear = useCallback(() => setRequest(null), []);

    return {
        pending: getPendingRemuxRequest(request, mergingStatus),
        blocker: remuxRequestBlocker(request, mergingStatus, languageName),
        record,
        clear,
    };
};
